const heroCards = [
  {
    icon: "ri-heart-3-line",
    title: "缘分匹配",
    desc: "按城市与兴趣推荐更契合的人选。",
    href: "#matching",
    role: "primary" as const,
  },
  {
    icon: "ri-group-line",
    title: "单身群",
    desc: "从共同话题开始，慢热也不尴尬。",
    href: "#groups",
    role: "accent" as const,
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "主题聊天室",
    desc: "六个常驻房间，随时有人接着聊。",
    href: "#chatrooms",
    role: "secondary" as const,
  },
  {
    icon: "ri-map-pin-2-line",
    title: "同城活动",
    desc: "拼桌、看展、citywalk，把好感落地。",
    href: "#cities",
    role: "primary" as const,
  },
];

const roleClasses: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function Hero() {
  return (
    <section id="home" className="anchor-offset relative overflow-hidden pt-[72px]">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-primary-50 via-background-50 to-background-50" aria-hidden="true"></div>
      <div className="mx-auto flex max-w-content flex-col gap-10 px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-start gap-5">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-map-pin-user-line" aria-hidden="true"></i>
            同城交友 · 婚恋缘分 · 单身群
          </span>
          <h1 className="max-w-3xl font-heading text-3xl leading-snug text-foreground-950 md:text-5xl md:leading-tight">
            在爱情岛，遇见同一座城市的那个 TA
          </h1>
          <p className="max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            爱情岛是一个面向同城单身男女的交友社区。我们不做尬聊式拉郎配，而是用婚恋匹配帮你缩小范围，用单身群和聊天室帮你自然开口，
            让缘分从一次轻松的对话开始。
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="#cities"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-compass-3-line" aria-hidden="true"></i>
              探索同城交友圈
            </a>
            <a
              href="#groups"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-group-line" aria-hidden="true"></i>
              逛一逛单身群
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-600">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line text-primary-600" aria-hidden="true"></i>实名认证
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-lock-2-line text-primary-600" aria-hidden="true"></i>隐私可控
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-map-pin-2-line text-primary-600" aria-hidden="true"></i>同城优先
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-user-heart-line text-primary-600" aria-hidden="true"></i>认真恋爱氛围
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {heroCards.map((card) => (
            <a
              key={card.title}
              href={card.href}
              className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 cursor-pointer"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${roleClasses[card.role]}`}>
                <i className={`${card.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg text-foreground-950">{card.title}</span>
              <span className="text-sm leading-relaxed text-foreground-600">{card.desc}</span>
              <span className="mt-auto inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                了解详情
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}